import axios from "axios";
import { baseUrl } from "./constants";

// Interfaces
export interface ChatSessionDetail {
  source_entity: string;
  username: string;
  user_email: string;
  uid: string;
  name: string;
  created: string;
  has_trip_summary: boolean;
  trip_summary: string | null;
}

export interface GetChatSessionResponse {
  session: ChatSessionDetail;
}

// Axios request
export async function getChatSession(sessionId: string): Promise<GetChatSessionResponse> {
  const response = await axios.get<GetChatSessionResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/sessions/by-session-uid/${sessionId}`,
  );
  return response.data;
}
